export const bannerWhyUsTextContent = {
  content: [
    {
      titleText: (
        <>
          About <span>GammaStack</span>
        </>
      ),
      paraText:
        "GammaStack is a leading IT solutions provider with over 13 years of experience and a team of 350+ developers. We specialize in iGaming software, including sports betting, online casinos, game development, live dealer casinos, and fantasy sports. Whether building a platform from scratch or customizing it, we deliver innovative, cutting-edge solutions quickly. Our expertise is reinforced through successful projects and strong partnerships with major industry providers, ensuring impactful results.",
      btnText: "Contact Us",
      imageSrc: "/assets/stock-img/banner_character_img_04.webp",
    },
  ],
};
